"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkspaceUsers = void 0;
var sdk_ui_1 = require("@gooddata/sdk-ui");
var model_1 = require("../../../model");
/**
 * Hook allowing to download workspace users
 * @param config - configuration of the hook
 * @internal
 */
function useWorkspaceUsers(_a) {
    var search = _a.search, backend = _a.backend, workspace = _a.workspace, onCancel = _a.onCancel, onError = _a.onError, onLoading = _a.onLoading, onPending = _a.onPending, onSuccess = _a.onSuccess;
    var effectiveBackend = sdk_ui_1.useBackendStrict(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspaceStrict(workspace);
    var canListUsersInWorkspace = model_1.useDashboardSelector(model_1.selectCanListUsersInWorkspace);
    // if the user cannot list the users, do not even try and resolve to an empty array
    var promise = canListUsersInWorkspace
        ? function () {
            var loader = effectiveBackend.workspace(effectiveWorkspace).users();
            if (search) {
                loader = loader.withOptions({ search: "%" + search });
            }
            return loader.queryAll();
        }
        : function () { return Promise.resolve([]); };
    return sdk_ui_1.useCancelablePromise({ promise: promise, onCancel: onCancel, onError: onError, onLoading: onLoading, onPending: onPending, onSuccess: onSuccess }, [
        effectiveBackend,
        effectiveWorkspace,
        search,
    ]);
}
exports.useWorkspaceUsers = useWorkspaceUsers;
//# sourceMappingURL=useWorkspaceUsers.js.map